import { render, staticRenderFns } from "./PublicMasterGoal.vue?vue&type=template&id=45390d9c&"
import script from "./PublicMasterGoal.vue?vue&type=script&lang=js&"
export * from "./PublicMasterGoal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports